<template>
  <div class="block-n_05">
    <div class="s4_m">
      <!--<div class="tagContenta sia" v-for="(scheduler,index) in schedulers" :key="index">
        <div class="div05 clearfix">
          <div class="div05-L clearfix">
            <a href=""><img :src="scheduler.img"/>&lt;!&ndash;<span>已做</span>&ndash;&gt;</a>

          </div>
          <div class="div05-R clearfix">
            <h3>{{scheduler.treatmentNames}}</h3>
            &lt;!&ndash;<p>
              <span>10,000积分</span>抵扣<span>10元</span>，<br/><span>10,000��</span>抵扣<span>10元</span>，<br/><span>10,000华韩金</span>抵扣<span>10元</span>，<br/>实付：<span>998元</span>
            </p>&ndash;&gt;
            <br/>
            <p class="p03">{{scheduler.beginTime}}至{{scheduler.endTime}}</p>
          </div>
        </div>

        <div class="clear"></div>
      </div>-->
      <div class="tagContenta">
        <div class="div05 clearfix" id="div05">
          <div class="div06">
            <img src="../../../static/img/L.png"/><br/>您还没有未排上的项目！
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import schedulerService from '../../services/scheduler-service'
  import {Toast} from 'mint-ui'

  export default {
    data () {
      return {

      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/scheduler/NotArrangement.vue